/* jshint esversion: 6 */
/* jshint ignore:start */
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { LuChevronRight } from "react-icons/lu";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "../ImageLoad";

const OurServices = () => {
  const { t } = useTranslation();

  const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

  const [labData, setLabData] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const NavigateHandle = (title, id) => {
    navigate("/doctor-details");
    sessionStorage.setItem(
      "Docdetails",
      JSON.stringify({
        id: id,
        title: title,
        path: "/services",
        pagename: "Our Services",
      }),
    );
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      const lat = String(position.coords.latitude);
      const long = String(position.coords.longitude);
      fetchHomeData(lat, long);
    });
  }, []);

  const fetchHomeData = (lat, long) => {
    const Userid = secureLocalStorage.getItem("Userid") || "0";
    if (Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/home`, {
          id: Userid,
          lat: lat,
          lon: long,
        })
        .then((res) => {
          const { department_list, ResponseCode } = res.data;
          if (ResponseCode === 200) {
            setLabData(department_list);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Home Api", error);
        });
    }
  };

  useEffect(() => {
    loading
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [loading]);

  return (
    <div className="w-full width-container content-wrapper pb-[50px] px-4 md:px-6 max-w-7xl mx-auto">
      {loading ? (
        <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] z-[999] w-full flex items-center justify-center bg-white" />
      ) : (
        <div className="mt-[25px] ourservices">
          {/* Header Bar */}
          <div className="flex items-center justify-between mb-8">
            <Link
              to="/"
              className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black"
            >
              <IoIosArrowBack className=" group-hover:text-white" />
              <h1 className="font-[500] group-hover:text-white">
                {" "}
                {t("Go Home")}
              </h1>
            </Link>
            <div className="flex items-center gap-[10px] max-_430_:hidden">
              <Link to="/" className="font-[500] text-gray-700">
                {t("Home")}
              </Link>
              <IoIosArrowForward />
              <h1 className="font-[500] text-gray-400">{t("Our Services")}</h1>
            </div>
            <div className="border-[2px] border-gray-200 rounded-[50px] px-[20px] py-[2px] hidden max-_430_:block">
              <Link to="/" className="font-[500] text-gray-600">
                Back
              </Link>
            </div>
          </div>

          {/* Section Title */}
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-slate-800 tracking-tight">
              {t("Our Services")}
            </h2>
            <p className="text-sm text-slate-500 mt-1">
              {t("Browse our medical specialties and book an appointment.")}
            </p>
          </div>

          {/* Services Grid — same style as Shop categories */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 mt-[20px]">
            {labData.map((item, index) => (
              <div
                key={index}
                onClick={() => NavigateHandle(item.name, item.id)}
                className="group bg-white rounded-2xl border border-slate-150 hover:border-indigo-500/30 cursor-pointer shadow-sm hover:shadow-md hover:-translate-y-1.5 transition-all duration-350 p-5 flex flex-col justify-center items-center text-center relative overflow-hidden"
              >
                {/* Gradient overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-b from-indigo-50/0 to-indigo-50/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                {/* Circular image bubble */}
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-slate-50 group-hover:bg-indigo-50/80 flex items-center justify-center p-3 mb-4 transition-all duration-300 relative z-10">
                  <ImageLoad
                    src={ImgBaseUrl + item.image}
                    CustomeStyle="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110"
                    alt={item.name}
                  />
                </div>

                {/* Name */}
                <h3 className="font-semibold text-slate-800 text-sm md:text-base group-hover:text-indigo-600 transition-colors duration-200 line-clamp-1 w-full relative z-10">
                  {item.name}
                </h3>

                {/* Explore badge — slides in on hover */}
                <span className="text-[11px] font-medium text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded-full mt-2.5 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-1 group-hover:translate-y-0 relative z-10">
                  {t("Explore")}{" "}
                  <LuChevronRight className="inline-block w-3 h-3 -mt-0.5" />
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default OurServices;
/* jshint ignore:end */
